<template>
  <div>
    <v-card>
      <v-card-title>Présentation</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="clientPortal.portal == 0">V2</span>
                    <span v-if="clientPortal.portal == 1">V3</span>
                    <span v-if="clientPortal.portal == 2">V4</span>
                    <span v-if="clientPortal.portal == 3">V5</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>Version</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="6">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ clientPortal.portalName }}
                  </v-list-item-title>
                  <v-list-item-subtitle>Modèle</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" md="6">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <div v-if="clientPortal.isBuiltin">
                      {{ clientPortal.portalOptions.name }}
                    </div>
                    <div v-else>-</div>
                  </v-list-item-title>
                  <v-list-item-subtitle>Template</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="6">
            <v-list two-line>
              <v-list-item @click="portalPresentationModelDialog = true">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if="clientPortal.isInherit" small>
                      mdi-radiobox-marked
                    </v-icon>
                    <span v-else>-</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>Héritage</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <v-list two-line class="pb-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <div
                      v-if="
                        clientPortal.portalConfiguration.basic_presentation !=
                          null &&
                        clientPortal.portalConfiguration.basic_presentation
                          .access != null &&
                        clientPortal.portalConfiguration.basic_presentation
                          .access.length > 0
                      "
                    >
                      {{
                        clientPortal.portalConfiguration.basic_presentation.access
                          .toString()
                          .toUpperCase()
                      }}
                      ({{
                        clientPortal.portalConfiguration.basic_presentation
                          .payment
                      }})
                    </div>
                    <div v-else>-</div>
                  </v-list-item-title>
                  <v-list-item-subtitle>Basic</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="6" class="pb-0">
            <v-list two-line class="pb-0">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <div
                      v-if="
                        clientPortal.portalConfiguration.full_presentation !=
                          null &&
                        clientPortal.portalConfiguration.full_presentation
                          .access != null &&
                        clientPortal.portalConfiguration.full_presentation
                          .access.length > 0
                      "
                    >
                      {{
                        clientPortal.portalConfiguration.full_presentation.access
                          .toString()
                          .toUpperCase()
                      }}
                      ({{
                        clientPortal.portalConfiguration.full_presentation
                          .payment
                      }})
                    </div>
                    <div v-else>-</div>
                  </v-list-item-title>
                  <v-list-item-subtitle>Full</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <edit-portal-presentation-model-form
      v-if="clientPortal.portal == '3' && portalPresentationModelDialog"
      :isInherit="clientPortal.isInherit"
      :isBuiltIn="clientPortal.isBuiltin"
      :portalConfiguration="clientPortal.portalConfiguration"
      :portalConfigurationModel="clientPortal.portalConfigurationModel"
      :updatePortalConfiguration="updatePortalConfigurationModel"
      :id="String(clientPortal.id)"
      :group="clientPortal.group"
      :partner="clientPortal.partner"
      :portalPresentationModelDialog.sync="portalPresentationModelDialog"
      :rules="rules"
      :portalOptionsId="clientPortal.portalOptionsId"
    ></edit-portal-presentation-model-form>
  </div>
</template>
<script>
import { defineComponent, toRefs } from "@vue/composition-api";
import EditPortalPresentationModelForm from "@/components/PortalConfiguration/EditPortalPresentationModelForm";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  components: {
    EditPortalPresentationModelForm,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup() {
    /* Import des API */
    const {
      data,
      updatePortalConfiguration,
      updatePortalConfigurationModel,
    } = useClientPortal();

    return {
      ...toRefs(data),
      updatePortalConfiguration,
      updatePortalConfigurationModel,
    };
  },
});
</script>
